/**
 * RAHUL IAS ACADEMY — MAIN JAVASCRIPT
 * Solan, Himachal Pradesh, India
 * Production Vanilla JavaScript for Hostinger Shared Hosting
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. STICKY HEADER SCROLL LISTENER
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    });
  }

  // 2. MOBILE DRAWER NAVIGATION MENU
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileDrawer = document.querySelector('.mobile-drawer');
  const drawerCloseBtn = document.querySelector('.drawer-close-btn');
  const overlay = document.querySelector('.overlay');

  function openMobileNav() {
    if (mobileDrawer) mobileDrawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (mobileDrawer) mobileDrawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeMobileNav);
  if (overlay) overlay.addEventListener('click', closeMobileNav);

  // Close nav on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobileNav();
  });

  // 3. FAQ ACCORDION
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach((item) => {
    const trigger = item.querySelector('.faq-trigger');
    const content = item.querySelector('.faq-content');

    if (trigger && content) {
      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-active');

        // Close other items
        faqItems.forEach((other) => {
          other.classList.remove('is-active');
          const otherContent = other.querySelector('.faq-content');
          if (otherContent) otherContent.style.maxHeight = null;
        });

        // Toggle current item
        if (!isOpen) {
          item.classList.add('is-active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }
  });

  // 4. GALLERY FILTER & LIGHTBOX MODAL
  const filterBtns = document.querySelectorAll('.filter-btn');
  const galleryItems = document.querySelectorAll('.gallery-item');

  if (filterBtns.length > 0 && galleryItems.length > 0) {
    filterBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        filterBtns.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');

        const filterVal = btn.getAttribute('data-filter');

        galleryItems.forEach((item) => {
          const itemCat = item.getAttribute('data-category');
          if (filterVal === 'all' || filterVal === itemCat) {
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  }

  // Lightbox Modal Functionality
  const lightboxModal = document.querySelector('.lightbox-modal') || document.querySelector('.lightbox');
  const lightboxImg = document.querySelector('.lightbox-img') || document.getElementById('lightboxImage');
  const lightboxCaption = document.querySelector('.lightbox-caption') || document.getElementById('lightboxCaption');
  const lightboxClose = document.querySelector('.lightbox-close');

  if (galleryItems.length > 0 && lightboxModal && lightboxImg) {
    galleryItems.forEach((item) => {
      item.addEventListener('click', () => {
        const img = item.querySelector('img');
        const caption = item.querySelector('.gallery-caption') || item.querySelector('.gallery-overlay-caption');

        if (img) {
          lightboxImg.src = img.src;
          lightboxImg.alt = img.alt || 'Rahul IAS Academy Solan';
        }
        if (caption && lightboxCaption) {
          lightboxCaption.textContent = caption.textContent.trim();
        } else if (lightboxCaption) {
          lightboxCaption.textContent = img ? img.alt : '';
        }

        lightboxModal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });
    });

    if (lightboxClose) {
      lightboxClose.addEventListener('click', () => {
        lightboxModal.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    }

    lightboxModal.addEventListener('click', (e) => {
      if (e.target === lightboxModal) {
        lightboxModal.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }

  // 5. COURSE PRE-SELECTION FROM URL PARAMETER (?course=upsc)
  const urlParams = new URLSearchParams(window.location.search);
  const courseParam = urlParams.get('course');
  const courseSelect = document.getElementById('enquiryCourseSelect');

  if (courseParam && courseSelect) {
    for (let i = 0; i < courseSelect.options.length; i++) {
      if (courseSelect.options[i].value.toLowerCase().includes(courseParam.toLowerCase())) {
        courseSelect.selectedIndex = i;
        break;
      }
    }
  }

  // 6. TRACKABLE CTA DATA ATTRIBUTES LOGGING
  const ctaElements = document.querySelectorAll('[data-cta]');
  ctaElements.forEach((el) => {
    el.addEventListener('click', () => {
      const ctaType = el.getAttribute('data-cta');
      if (window.gtag) {
        window.gtag('event', 'cta_click', {
          cta_type: ctaType,
          page_path: window.location.pathname,
        });
      }
      console.log(`[Rahul IAS Academy Analytics] CTA Clicked: ${ctaType}`);
    });
  });

  // 7. LEAD POPUP MODAL CONTROL
  const modalPopup = document.querySelector('.modal-popup');
  const modalCloseBtn = document.querySelector('.modal-close-btn');
  const triggerModalBtns = document.querySelectorAll('[data-trigger-modal]');

  if (modalPopup) {
    triggerModalBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        modalPopup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });
    });

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', () => {
        modalPopup.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    }

    modalPopup.addEventListener('click', (e) => {
      if (e.target === modalPopup) {
        modalPopup.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }

  // 8. DESKTOP SELECTED STUDENTS 4-CARD CAROUSEL
  const carouselContainer = document.getElementById('homeAchieversCarousel');
  const carouselTrack = document.getElementById('carouselTrack');
  const prevBtn = document.getElementById('carouselPrevBtn');
  const nextBtn = document.getElementById('carouselNextBtn');
  const dotsContainer = document.getElementById('carouselDots');

  if (carouselContainer && carouselTrack && prevBtn && nextBtn && dotsContainer) {
    const cards = carouselTrack.querySelectorAll('.achiever-card');
    const totalCards = cards.length;
    const cardsPerView = 4;
    let currentIndex = 0;
    let autoPlayTimer = null;

    const isDesktop = () => window.innerWidth >= 992;
    const getMaxIndex = () => Math.max(0, totalCards - cardsPerView);

    // Build indicator dots
    function renderDots() {
      dotsContainer.innerHTML = '';
      const maxIndex = getMaxIndex();
      for (let i = 0; i <= maxIndex; i++) {
        const dot = document.createElement('button');
        dot.className = `carousel-dot ${i === currentIndex ? 'active' : ''}`;
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          goToIndex(i);
          resetAutoPlay();
        });
        dotsContainer.appendChild(dot);
      }
    }

    // Update track position and active states
    function updateCarousel() {
      if (!isDesktop()) {
        carouselTrack.style.transform = '';
        return;
      }

      const maxIndex = getMaxIndex();
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      if (currentIndex < 0) currentIndex = 0;

      if (cards.length > 0) {
        const cardRect = cards[0].getBoundingClientRect();
        // Calculate gap from computed style or fallback to 24px
        const trackStyle = window.getComputedStyle(carouselTrack);
        const gapVal = parseFloat(trackStyle.gap) || 24;
        const moveAmount = currentIndex * (cardRect.width + gapVal);
        carouselTrack.style.transform = `translateX(-${moveAmount}px)`;
      }

      // Update Prev / Next button states
      prevBtn.disabled = currentIndex === 0;
      prevBtn.classList.toggle('is-disabled', currentIndex === 0);
      nextBtn.disabled = currentIndex >= maxIndex;
      nextBtn.classList.toggle('is-disabled', currentIndex >= maxIndex);

      // Update dots
      const dots = dotsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((dot, idx) => {
        dot.classList.toggle('active', idx === currentIndex);
      });
    }

    function goToIndex(index) {
      const maxIndex = getMaxIndex();
      if (index < 0) {
        currentIndex = maxIndex; // wrap around
      } else if (index > maxIndex) {
        currentIndex = 0; // wrap around
      } else {
        currentIndex = index;
      }
      updateCarousel();
    }

    function nextSlide() {
      const maxIndex = getMaxIndex();
      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }
      updateCarousel();
    }

    function prevSlide() {
      const maxIndex = getMaxIndex();
      if (currentIndex <= 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex--;
      }
      updateCarousel();
    }

    function startAutoPlay() {
      if (!isDesktop()) return;
      stopAutoPlay();
      autoPlayTimer = setInterval(() => {
        nextSlide();
      }, 5000);
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer);
        autoPlayTimer = null;
      }
    }

    function resetAutoPlay() {
      stopAutoPlay();
      startAutoPlay();
    }

    // Event listeners for Navigation Buttons
    prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoPlay();
    });

    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoPlay();
    });

    // Pause on Hover
    carouselContainer.addEventListener('mouseenter', stopAutoPlay);
    carouselContainer.addEventListener('mouseleave', startAutoPlay);

    // Keyboard navigation
    carouselContainer.addEventListener('keydown', (e) => {
      if (!isDesktop()) return;
      if (e.key === 'ArrowLeft') {
        prevSlide();
        resetAutoPlay();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        resetAutoPlay();
      }
    });

    // Handle Window Resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (isDesktop()) {
          renderDots();
          updateCarousel();
          startAutoPlay();
        } else {
          stopAutoPlay();
          carouselTrack.style.transform = '';
        }
      }, 150);
    });

    // Initial setup
    renderDots();
    updateCarousel();
    if (isDesktop()) {
      startAutoPlay();
    }
  }

  // 9. SMART PROGRESSIVE IMAGE FALLBACK & INSTANT RECOVERY
  // Ensures any uploaded photo (whether .jpg, .jpeg, .png, .webp, or .svg) renders immediately without breaking
  const EXTENSIONS_TO_TRY = ['.jpg', '.jpeg', '.png', '.webp', '.svg'];

  function setupSmartImage(img) {
    if (img.dataset.smartImgInit) return;
    img.dataset.smartImgInit = 'true';

    img.addEventListener('error', function handleImageError() {
      const currentSrc = this.currentSrc || this.src;
      if (!currentSrc || currentSrc.startsWith('data:')) return;

      // Extract URL parts without query parameters
      const urlObj = new URL(currentSrc, window.location.origin);
      const pathname = urlObj.pathname;
      const dotIndex = pathname.lastIndexOf('.');
      if (dotIndex === -1) return;

      const basePath = pathname.substring(0, dotIndex);
      const currentExt = pathname.substring(dotIndex).toLowerCase();

      // Track tried extensions
      let tried = [];
      try {
        tried = JSON.parse(this.dataset.fallbackTried || '[]');
      } catch (e) {
        tried = [];
      }

      if (!tried.includes(currentExt)) {
        tried.push(currentExt);
      }

      // Find next untried extension
      const nextExt = EXTENSIONS_TO_TRY.find((ext) => !tried.includes(ext));

      if (nextExt) {
        tried.push(nextExt);
        this.dataset.fallbackTried = JSON.stringify(tried);
        // Try the new extension with timestamp to avoid cached 404s
        this.src = `${basePath}${nextExt}?t=${Date.now()}`;
      } else {
        // All common extensions failed -> render a polished SVG fallback card with the image's alt title
        const altText = this.alt || 'Rahul IAS Academy Solan';
        const width = this.getAttribute('width') || 400;
        const height = this.getAttribute('height') || 280;
        
        const fallbackSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" width="100%" height="100%">
          <rect width="100%" height="100%" fill="#002B49"/>
          <circle cx="${width/2}" cy="${height/2 - 15}" r="32" fill="rgba(212, 175, 55, 0.2)"/>
          <path d="M ${width/2 - 16} ${height/2 - 5} L ${width/2} ${height/2 - 25} L ${width/2 + 16} ${height/2 - 5} Z" fill="#D4AF37"/>
          <text x="50%" y="${height/2 + 25}" fill="#FFFFFF" font-size="14" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" font-weight="600" text-anchor="middle">${altText.length > 35 ? altText.substring(0, 32) + '...' : altText}</text>
          <text x="50%" y="${height/2 + 45}" fill="#C0C9D0" font-size="11" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" text-anchor="middle">Rahul IAS Academy Solan</text>
        </svg>`;

        this.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(fallbackSvg)}`;
        this.classList.add('img-fallback-loaded');
      }
    });
  }

  // Initialize for all existing images
  document.querySelectorAll('img').forEach(setupSmartImage);

  // Monitor DOM for any dynamically added images
  const imgObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.tagName === 'IMG') {
            setupSmartImage(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('img').forEach(setupSmartImage);
          }
        }
      });
    });
  });

  imgObserver.observe(document.body, { childList: true, subtree: true });
});

